import { ProtectedRoute } from '@components/protectedRoute';
import { InventoryProvider } from '@contexts/inventory';
import { InventoryQuantitiesProvider } from '@contexts/inventory/quantities';
import { appRoutes, usersAccessList } from '@utils/consts';

export const inventoryRoutes = [
  {
    path: appRoutes.inventory,
    lazy: async () => {
      const { Inventory } = await import('@pages/inventory');
      return {
        Component: () => (
          <ProtectedRoute allowedRoles={usersAccessList(appRoutes.inventory)}>
            <InventoryProvider>
              <InventoryQuantitiesProvider>
                <Inventory />
              </InventoryQuantitiesProvider>
            </InventoryProvider>
          </ProtectedRoute>
        ),
      };
    },
  },
];
